import { createContext, useContext, useState } from "react";

/**
 * Contexto que comparte el estado actual de la calculadora con
 * el formulario de contacto, para que al enviar se incluya el
 * plan de pago detallado en el mensaje.
 */
const CalculadoraContext = createContext({
    snapshot: null,
    setSnapshot: () => {},
});

export function CalculadoraProvider({ children }) {
    const [snapshot, setSnapshot] = useState(null);
    return (
        <CalculadoraContext.Provider value={{ snapshot, setSnapshot }}>
            {children}
        </CalculadoraContext.Provider>
    );
}

export const useCalculadora = () => useContext(CalculadoraContext);

/**
 * Construye el mensaje formateado estilo WhatsApp con el plan de pago.
 */
export function buildPlanMessage(snap) {
    if (!snap) return "";
    const fmt = (v) =>
        new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
        }).format(v || 0);

    const titulo = `${snap.nombreMaestria} - ${snap.cohorte || "COHORTE I - 2026"}`;

    if (snap.modalidad === "contado") {
        const lineas = [
            `📋 *Plan de Contado -`,
            `${titulo}*`,
            ``,
            `📌 Precio Regular: ${fmt(snap.valorPrograma)}`,
        ];
        if (snap.descuentoPct > 0) {
            lineas.push(
                `🎁 Descuento (${snap.descuentoPct}%): -${fmt(snap.ahorroContado)}`
            );
        }
        lineas.push(`✨ *Total a Pagar: ${fmt(snap.totalContado)}*`);
        return lineas.join("\n");
    }

    // Diferido
    const lineas = [
        `📋 *Plan de Financiamiento -`,
        `${titulo}*`,
        ``,
        `📌 Precio Regular: ${fmt(snap.valorPrograma)}`,
    ];
    if (snap.descuentoPlazoCorto > 0) {
        lineas.push(
            `🎁 Descuento promo (${snap.plazo} cuotas): -${fmt(snap.descuentoPlazoCorto)}`
        );
    }
    lineas.push(
        `📗 Cuota Inicial: ${fmt(snap.cuotaInicial)}`,
        `📊 Monto a Diferir: ${fmt(snap.saldo)}`,
        `📋 Cuotas: ${snap.plazo} cuotas de *${fmt(snap.cuotaMensual)}*`,
        ``,
        `✨ *Total a Pagar: ${fmt(snap.totalAPagar)}*`
    );
    return lineas.join("\n");
}
